import axios from 'axios'
import Vue from 'vue'
/**
 *  metodo para crear el usuario
 * @param {*} context 
 * @param {*} form 
 */
export async function create (context,form){
    try{
        let url = "api/adduser"//la direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('username',form.username)
        values.append('password',form.password) 
        values.append('nombre',form.nombre)
        values.append('email',form.email)
        values.append('telefono',form.telefono)
        values.append('rol_id',form.rol_id)
        values.append('vsap',form.vsap)
        
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })  
        context.commit('setIsOk', true)//si todo esta bien  llamamos a la mutacion y la seteamos en true.
    }catch(error){
        context.commit('adminError', error) // guardamos el mensaje de error
    }
    finally{
        context.commit('setLoading',false,{root:true}) // finalizamos el loading
    }
   
}

/**
 *  metodo que busca los usuarios
 * @param {*} context 
 */
export async function fetchUsers (context){
    try{
    let url = "api/getusers"//la direccion de la api
   
    context.commit('setLoading',true,{root:true}) //lanzamos el loading

    let response = await Vue.axios({
        method: 'GET',
        url: url
    })
         
    context.commit('setUsers',response.data.data.data)
  
    }catch(error){
        context.commit('adminError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
   
}
/**
 *  metodo que elimina el usuario del sistema.
 * @param {*} context 
 * @param {*} form 
 */
export async function eliminar (context,payload){
    try{
        let url = "api/deleteuser"//direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('id',payload.id)
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })  
        context.commit('setIsOk', true)//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchUsers')
    }catch(error){
        context.commit('adminError',error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function update (context,form){
    try{
        let url = "api/updateuser"//la direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('id',form.id)
        values.append('username',form.username)
        //values.append('password',form.password) 
        values.append('nombre',form.name)
        values.append('email',form.email)
        values.append('telefono',form.telefono)
        values.append('rol_id',form.rol_id)
        values.append('vsap',form.vsap)
        
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })  
        context.commit('setIsOk', true)//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchUsers')
    }catch(error){
        context.commit('adminError', error) // guardamos el mensaje de error
    }
    finally{
        context.commit('setLoading',false,{root:true}) // finalizamos el loading
    }
   
}

export async function cambiacontrasena(context,payload){
    try{
        context.commit('setLoading',true,{root:true}) // lanzamos el loading
        let url = "api/updatepassword"//la direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        let values = new FormData()
        values.append('id',payload.id)
        values.append('password',payload.password)
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values

        })
        context.commit('setIsOk', true)//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchUsers')
    }catch(error){
        context.commit('adminError', error) // guardamos el mensaje de error
    }finally{
        context.commit('setLoading',false,{root:true}) // finalizamos el loading
    }
}

/**
 *  metodo que busca los usuarios
 * @param {*} context 
 */
export async function fetchVendedores (context){
    try{
        let url = "api/getvendedores"//la direccion de la api 
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })     
        context.commit('setVendedores',response.data.data.data)
    }catch(error){
        context.commit('adminError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
   
}

export async function updateVendedor(context, payload){
    try{
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let url = "api/updatevendedor"//la direccion de la api 
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        let values = new FormData()
        values.append('id',payload.id)
        values.append('vendedor',payload.vendedor)
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        }) 
        context.commit('setIsOk', true)//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchVendedores')
    }catch (error){
        context.commit('adminError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function deleteVendedor (context,form){
    try{
        let url = "api/deletevendedor"//direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('id',form.id)
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })  
        context.commit('setIsOk', true)//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchVendedores')
    }catch(error){
        context.commit('adminError',error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function fetchSolicitantes (context){
    try{
        let url = "api/getsolicitantes"//la direccion de la api 
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()      
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })     
        context.commit('setSolicitantes',response.data)
    }catch(error){
        context.commit('adminError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
   
}

export async function createVendedor (context,payload){
    try{
        let url = "api/addvendedor"//la direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('vendedor',payload.vendedor)        
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })  
        context.commit('setIsOk', true)//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchVendedores') // actualiza los vendedores
    }catch(error){
        context.commit('adminError', error) // guardamos el mensaje de error
    }
    finally{
        context.commit('setLoading',false,{root:true}) // finalizamos el loading
    }
   
}
export async function fetchInactiveUsers (context){
    try{
    let url = "api/getinactiveusers"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    let values = new FormData()
    values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')    
    let response = await Vue.axios({
        method: 'POST',
        url: url,
        data: values
    })
         
    context.commit('setUsers',response.data.data.data)
  
    }catch(error){
        context.commit('adminError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
   
}
export async function activar (context,payload){
    try{
        let url = "api/activeuser"//direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('id',payload.id)
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })  
        context.commit('setIsOk', true)//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchInactiveUsers')
    }catch(error){
        context.commit('adminError',error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}